const state = {
  step: 0, // 进度条
  componentName: 'selectTemplate', // 当前显示的组件名称
  templateFile: null, // 添加的客户模板文件
  templateFilePath: '', // 添加的客户模板文件路径
  importTemplateIndex: null, // 当前导入选中模板下标
  importTemplate: null, // 当前选中模板(对象)

  importStep: 0, // 当前导入步骤
  
  filePath: '', //当前选中模板路径
  file: null,
  editId: null, // 当前修改的id
  editType: null, // 当前操作类型
  importResult: {}, // 导入结果
}

const mutations = {
  setStep (state, value) {
    state.importStep = value;
  },
  setTemplateIndex (state, value) {
    state.importTemplateIndex = value;
  },
  setFilePath (state, path) {
    state.filePath = path;
  },
  setFile (state, file) {
    state.file = file;
  },
  setEditId (state, id) {
    state.editId = id;
  },
  setResult (state, data) {
    state.importResult = data;
  },
  clear () {
    state.step= 0;
    state.componentName= 'selectTemplate';
    state.templateFile= null;
    state.templateFilePath= '';
    state.importTemplateIndex= null;
    state.importTemplate= null;
    state.editType = null;
    state.importStep = 0;
    state.importTemplateIndex = null;
    state.filePath = '';
    state.editId = '';
    state.importResult = {};
    state.file = null;
  },
  // 设置跳转模板操作页类型
  setTemplate (state, {id, step, type, name}) {
    state.step = step;
    state.editId = id;
    state.editType = type;
    state.componentName = name;
  },
  // 设置当前跳转的模块
  setSteps (state, {step, name}) {
    state.step = step;
    state.componentName = name;
  },
  // 设置上传的模板文件
  setTemplateFile (state, {path, file}) {
    state.templateFile = file;
    state.templateFilePath = path;
  },
  // 设置当前选中模板内容
  setCurrentTemplate (state, {index, data}) {
    state.importTemplateIndex = index;
    state.importTemplate = data;
  }
}

const actions = {
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
